import { Map } from 'immutable';

import * as t from '../../actions/accountSettingsActionTypes';

const initialState = Map({
  updateProfilePrivacyMessage: { type: 'success', text: '' },
  updateProfilePrivacyWaiting: false,

  updateFlashcardWaiting: false,
  updateFlashcardMessage: { type: 'success', text: '' },

  flashcardOnly: '',
  uploadImageMessage: { type: 'success', text: '' },
  uploadImageWaiting: false,
  uploadingImageSuccess: false,

  updateUsernameMessage: { type: 'success', text: '' },
  updateUsernameWaiting: false,

  updatePersonalDataMessage: { type: 'success', text: '' },

  updateTimezoneMessage: { type: 'success', text: '' },
  updateTimezoneWaiting: false,

  updateEmailMessage: { type: 'success', text: '' },
  updateEmailWaiting: false,

  updateRateMessage: { type: 'success', text: '' },
  updateRateWaiting: false,

  updateRatingExamMessage: { type: 'success', text: '' },
  updateRatingExamWaiting: false,
  updateRatingExamSuccess: false,

  updatePasswordWaiting: false,
  updatePasswordMessage: { type: 'success', text: '' },

  updateCycleWaiting: false,

  switchPfeSkt: '',
  switchPfeSktWaiting: false,
  switchPfeSktMessage: { type: 'success', text: '' },
});

const reducer = function mainAccountSettingsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.SWITCH_PFE_SKT_WAITING:
      return state.set('switchPfeSktWaiting', action.value);
    case t.SWITCH_PFE_SKT_VALUE:
      return state.set('switchPfeSkt', action.value);
    case t.SWITCH_PFE_SKT_MESSAGE:
      return state.set('switchPfeSktMessage', action.value);
    case t.SET_UPDATE_CYCLE_WAITING:
      return state.set('updateCycleWaiting', action.value);
    case t.SET_UPDATE_USERNAME_WAITING:
      return state.set('updateUsernameWaiting', action.value);
    case t.SET_UPDATE_USERNAME_MESSAGE:
      return state.set('updateUsernameMessage', action.message);
    case t.SET_UPDATE_PERSONAL_DATA_MESSAGE:
      return state.set('updatePersonalDataMessage', action.message);
    case t.SET_UPDATE_PROFILE_PRIVACY_WAITING:
      return state.set('updateProfilePrivacyWaiting', action.value);
    case t.SET_UPDATE_PROFILE_PRIVACY_MESSAGE:
      return state.set('updateProfilePrivacyMessage', action.message);
    case t.SET_FLASHCARD_ONLY_WAITING:
      return state.set('updateFlashcardWaiting', action.value);
    case t.SET_FLASHCARD_ONLY_MESSAGE:
      return state.set('updateFlashcardMessage', action.message);
    case t.SET_FLASHCARD_ONLY:
      return state.set('flashcardOnly', action.value);
    case t.SET_UPDATE_TIMEZONE_WAITING:
      return state.set('updateTimezoneWaiting', action.value);
    case t.SET_UPDATE_TIMEZONE_MESSAGE:
      return state.set('updateTimezoneMessage', action.message);
    case t.SET_UPDATE_RATE_WAITING:
      return state.set('updateRateWaiting', action.value);
    case t.SET_UPDATE_RATE_MESSAGE:
      return state.set('updateRateMessage', action.message);
    case t.SET_UPDATE_EMAIL_WAITING:
      return state.set('updateEmailWaiting', action.value);
    case t.SET_UPDATE_EMAIL_MESSAGE:
      return state.set('updateEmailMessage', action.message);
    case t.SET_UPLOAD_IMAGE_SUCCES:
      return state.set('uploadingImageSuccess', action.value);
    case t.SET_UPLOADING_IMAGE_WAITING:
      return state.set('uploadImageWaiting', action.value);
    case t.UPLOAD_IMAGE_MESSAGE:
      return state.set('uploadImageMessage', action.message);
    case t.SET_UPDATE_RATING_EXAM_SUCCESS:
      return state.set('updateRatingExamSuccess', action.value);
    case t.SET_UPDATE_RATING_EXAM_WAITING:
      return state.set('updateRatingExamWaiting', action.value);
    case t.SET_UPDATE_RATING_EXAM_MESSAGE:
      return state.set('updateRatingExamMessage', action.message);
    case t.SET_UPDATE_PASSWORD_WAITING:
      return state.set('updatePasswordWaiting', action.value);
    case t.SET_UPDATE_PASSWORD_MESSAGE:
      return state.set('updatePasswordMessage', action.message);
    default:
      return state;
  }
};

export default reducer;
